import httpClient from '../../services/httpClient';

export interface ServicePlan {
  id: number;
  name: string;
  price: number;
  picture?: string;
  description?: string;
  tier?: string | null;
  durationMonths?: number | null;
}

export interface OnlineService {
  id: number;
  name: string;
  price: number;
  picture: string;
  description: string;
  category?: string;
  platforms: string[];
  screenshots: string[];
  plans: ServicePlan[];
}

const arr = <T>(v: any): T[] => (Array.isArray(v?.$values) ? v.$values : Array.isArray(v) ? v : []);

export interface ServiceCard {
  id: number;
  name: string;
  price: number;
  picture: string;
}

export const serviceService = {
  // Список онлайн-сервисов, отфильтрованный по ServiceCategory (для страницы категории).
  list: async (category?: string): Promise<ServiceCard[]> => {
    const { data } = await httpClient.get('/api/OnlineService', {
      params: { category, pageNumber: 1, pageSize: 100 },
    });
    const items = arr<any>(data?.products ?? data);
    return items.map(d => ({
      id: d.id,
      name: d.name ?? '',
      price: Number(d.price ?? 0),
      picture: d.picture ?? '',
    }));
  },

  fetch: async (id: number): Promise<OnlineService> => {
    const { data } = await httpClient.get(`/api/onlineservice/${id}`);
    const d = data?.product ?? data;
    return {
      id: d.id,
      name: d.name ?? '',
      price: Number(d.price ?? 0),
      picture: d.picture ?? '',
      description: d.description ?? '',
      category: d.category,
      platforms: arr<string>(d.platforms),
      screenshots: arr<string>(d.screenshots),
      plans: arr<ServicePlan>(d.plans),
    };
  },
};
